<template>
  <header
    class="flex justify-between p-5 w-full"
    :class="$dm('bg-white', 'dark:bg-slate-900')"
  >
    <div class="flex items-center">
      <button v-if="showBackButton" @click="onBackButtonClick">
        <fluent-icon
          icon="chevron-left"
          size="24"
          :class="$dm('text-black-900', 'dark:text-slate-50')"
        />
      </button>
       <img
        v-if="avatarUrl"
        class="fixed-size-img mr-3"
        :src="avatarUrl"
        alt="Avatar"
      />
      <!-- <img
        v-if="avatarUrl"
        class="h-8 w-8 rounded-full mr-3"
        :src="avatarUrl"
        alt="avatar"
      /> -->
      <div class="align-content: center">
        <div
          class="font-medium text-base flex items-center header-span-name"
          :class="$dm('text-black-900', 'dark:text-slate-50')"
        >
          <span v-dompurify-html="title" class="mr-1" />
          <!-- <div
            :class="
              `h-2 w-2 rounded-full leading-4
              ${isOnline ? 'bg-green-500' : 'hidden'}`
            "
          /> -->
        </div>
        <!-- <div class="header-span-3">
          {{ replyWaitMessage }}
        </div> -->
      </div>
    </div>
    <header-actions :show-popout-button="showPopoutButton" />
  </header>
</template>

<script>
import { mapGetters } from 'vuex';

import availabilityMixin from 'widget/mixins/availability';
import FluentIcon from 'shared/components/FluentIcon/Index.vue';
import HeaderActions from './HeaderActions';
import routerMixin from 'widget/mixins/routerMixin';
import darkMixin from 'widget/mixins/darkModeMixin.js';

export default {
  name: 'ChatHeader',
  components: {
    FluentIcon,
    HeaderActions,
  },
  mixins: [availabilityMixin, routerMixin, darkMixin],
  props: {
    avatarUrl: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    showPopoutButton: {
      type: Boolean,
      default: false,
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
    availableAgents: {
      type: Array,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      widgetColor: 'appConfig/getWidgetColor',
      getDataIsChatOnLine: 'conversation/getDataIsChatOnLine',
    }),
    getIsChatOnLine() {
      return this.getDataIsChatOnLine.isChatOnline === true;
    },
    isOnline() {
      // const { workingHoursEnabled } = this.channelConfig;
      // const anyAgentOnline = this.availableAgents.length > 0;

      // if (workingHoursEnabled) {
      //   return this.isInBetweenTheWorkingHours;
      // }
      // return anyAgentOnline;
      return this.getIsChatOnLine;
    },
    replyWaitMessage() {
      // return this.getDataIsChatOnLine.onLineMassage;
      return this.isOnline
        ? this.replyTimeStatus
        : this.$t('TEAM_AVAILABILITY.OFFLINE');
    },
  },
  methods: {
    onBackButtonClick() {
      console.log('replaceRoute', this.$route.name);
      this.replaceRoute('home');
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap');

.header-span-name {
  font-family: 'Roboto' !important;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 19px !important;
  letter-spacing: 0.5px !important;
  color: #505d6f !important;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
}
.header-span-3 {
  height: 14px;
  font-family: 'Roboto';
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 14px !important;
  letter-spacing: 0.5px !important;
  color: #505d6f !important;
  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
}
.fixed-size-img {
  height: 30px !important;
  width: 30px !important;
  /* border-radius: 50% !important; */
}
</style>
